import * as z from "zod";

// NOTE (Max, 2026-08-04): naming convention for the currency of a money value.
// Canonical / internal commerce money always pairs an `amount` with a
// `currencyCode` (the ISO 4217 code, e.g. "USD"). The bare word `currency` is
// reserved for the edges where we mirror a third party's wire field — Stripe
// and Printful both call it `currency` — and it is converted to `currencyCode`
// at that boundary (e.g. the provider→canonical product mapper), exactly like
// we lowercase only at the Stripe edge. So `currency` vs `currencyCode` is a
// boundary distinction, not interchangeable synonyms: internal = currencyCode.
export const amountSchema = z
  .number()
  .int()
  .describe(
    "Integer amount in the currency's minor units (Stripe convention): 1999 = $19.99 USD, 1999 = ¥1999 JPY, 1999 = 1.999 KWD",
  );

/** An amount in minor units paired with its ISO 4217 currency code. */
export const amountWithCurrencyCodeSchema = z.object({
  amount: amountSchema,
  currencyCode: z.string(),
});
